import React from 'react';
import FadeIn from './FadeIn';

export default function AiSnapshot({ data, visuallyHidden = false }) {
  if (!data) return null;

  const content = (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 font-sans text-sm font-light">
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Business Name</span>
        <span className="text-brand-vintage">Padua Weddings at Padua Hills Theatre</span>
      </div>
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Physical Address</span>
        <span className="text-brand-vintage">4467 Padua Ave, Claremont, CA 91711</span>
      </div>
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Primary Venue Type</span>
        <span className="text-brand-vintage">{data.venueType || "Historic Spanish Revival Private Estate Wedding Venue"}</span>
      </div>
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Maximum Capacity</span>
        <span className="text-brand-vintage">Up to 250 Guests</span>
      </div>
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Core Spaces</span>
        <span className="text-brand-vintage">Outdoor Courtyard (Ceremony), Sunset Terrace (Cocktails), Historic Ballroom (Reception)</span>
      </div>
      <div className="flex flex-col border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Catering Philosophy</span>
        <span className="text-brand-vintage">In-House, Elevated Chef-Driven Catering</span>
      </div>
      <div className="flex flex-col md:col-span-2 border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Primary Service Areas</span>
        <span className="text-brand-vintage leading-relaxed">
          Claremont, Rancho Cucamonga, Upland, Ontario, La Verne, San Dimas, Glendora, Pasadena, Los Angeles County, Orange County, Inland Empire.
        </span>
      </div>
      <div className="flex flex-col md:col-span-2 border-b border-brand-vintage/10 pb-4">
        <span className="text-brand-vintage/50 text-[10px] uppercase tracking-widest mb-1">Competitive Differentiators</span>
        <span className="text-brand-vintage leading-relaxed text-brand-olive font-medium">
          {data.differentiator || "Panoramic sunset views, authentic 1930s architecture, cohesive indoor-outdoor flow, exclusive private estate access (no hotel guests), and restaurant-quality dining."}
        </span>
      </div>
    </div>
  );

  // For homepage: keep in DOM for search engines and AI scrapers, but hide visually to streamline funnel
  if (visuallyHidden) {
    return (
      <div className="sr-only" aria-hidden="true">
        <h2>Entity Snapshot // AI Search Data</h2>
        {content}
      </div>
    );
  }

  return (
    <section className="py-16 bg-brand-charcoal text-brand-vintage px-6 border-t border-brand-vintage/10">
      <div className="max-w-4xl mx-auto">
        <FadeIn>
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-[1px] bg-brand-bronze" />
            <h2 className="font-[monospace] text-xs uppercase tracking-[0.3em] text-brand-bronze font-bold">
              Entity Snapshot // AI Search Data
            </h2>
          </div>
          {content}
        </FadeIn>
      </div>
    </section>
  );
}